var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VPanel rounded-m overflow-h shadow-small"},[_c('div',{staticClass:"VPanel__Heading p-a-m hf-bg-toned-white border-b"},[_vm._t("heading")],2),_c('div',{staticClass:"VPanel__Body p-a-m hf-bg-white"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }